import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "mobx-react";
import { HashRouter } from "react-router-dom";
import { App } from "./App";
import { stores } from "./stores/storeContract"
import "./index.scss";

const renderApp = (root: Element, App: React.ComponentClass) => {

	ReactDOM.render(
		<Provider {...stores}>
			<HashRouter>
				<App />
			</HashRouter>
		</Provider>,
		root
	);
};

const root = document.getElementById("root");
renderApp(root, App);

if (module.hot) {
	module.hot.accept("./App", function() {
		const NewApp = require("./App").App;
		renderApp(root, NewApp);
	});
}
